
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Note extends Vue {
  @Prop() private value!: string;
}
